"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_hooks_1 = require("@apollo/react-hooks");
const graphql_1 = require("../../graphql");
exports.useChangePassword = (id, currentPassword, newPassword, opts) => {
    const [mutate, mutationResult] = react_hooks_1.useMutation(graphql_1.changePassword, Object.assign({ variables: {
            data: {
                currentPassword: currentPassword,
                id: id,
                password: newPassword,
            },
        } }, opts));
    return { mutate, mutationResult };
};
//# sourceMappingURL=useChangePassword.js.map